// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-module-style-normalize img,
.mt-module-style-normalize video{
  max-width: 100%;
  height: auto;
}


.mt-module-style-normalize img,
.mt-module-style-normalize svg,
.mt-module-style-normalize video,
.mt-module-style-normalize canvas,
.mt-module-style-normalize audio,
.mt-module-style-normalize iframe,
.mt-module-style-normalize embed,
.mt-module-style-normalize object {
  display: block;
  vertical-align: middle;
}

.mt-module-style-normalize .text-secondary-foreground {
  background-color: hsl(187 65% 92%) !important;
}
.mt-module-style-normalize .bg-secondary {
  background-color: hsl(187 65% 92%) !important;
}
.mt-module-style-normalize .p-4 {
  padding: 1rem !important;
}
.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100, .mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {
  opacity: 1 !important;
}

body > *:not(.mt-module-style-normalize) img,
body > *:not(.mt-module-style-normalize) svg,
body > *:not(.mt-module-style-normalize) video {
  display: initial;
}
body > *:not(.mt-module-style-normalize) .collapse{
  visibility: unset;
}

.mt-module-style-normalize{
  contain: style;
  padding: 0 !important;
}
@media (min-width: 1280px) {
  .mt-module-style-normalize .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
  .mt-module-style-normalize .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
  .mt-module-style-normalize .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5,minmax(0,1fr)) !important;
  } 
  .mt-module-style-normalize .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6,minmax(0,1fr)) !important;
  }
  .mt-module-style-normalize  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr)) !important;
  }
  .booking-view-top-card-view .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6,minmax(0,1fr)) !important;
  }
  .mt-module-style-normalize .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5,minmax(0,1fr)) !important;
  }
}
.mt-module-style-normalize .collapse {
  visibility: collapse;
}
.booking-calendar-view .booking-Calendar-container.flex.w-full{
  padding-left: 30px !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(198 88% 95%) !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(198 88% 28%) !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {
  background-color: hsl(198 88% 44%) !important;
}

.mt-dialog-style-normalize .bg-secondary {
  background-color: hsl(210 40% 96.1%);
}
.mt-dialog-style-normalize .text-secondary-foreground {
  color: hsl(215 25% 15%);
}
.mt-module-style-normalize .p-5 {
  padding: 1.25rem !important;
}
.mt-module-style-normalize .p-4 {
  padding: 1rem !important;
}
.mt-module-style-normalize .p-3 {
  padding: 0.75rem !important;
}
.mt-module-style-normalize .px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.mt-module-style-normalize .gap-4 {
  gap: 1rem !important;
}
.mt-module-style-normalize .py-4 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.mt-module-style-normalize .py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.mt-module-style-normalize .py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.mt-dialog-style-normalize .p-5 {
  padding: 1.25rem !important;
}
.mt-dialog-style-normalize .p-4 {
  padding: 0.75rem !important;
}
.mt-dialog-style-normalize .p-3 {
  padding: 0.5rem !important;
}
@media (min-width: 768px) {
  .mt-dialog-style-normalize .md\\:grid-cols-5 {
      grid-template-columns: repeat(5,minmax(0,1fr));
  }
  .mt-module-style-normalize .md\\:flex-row {
    flex-direction: row;
  }
}
@media (min-width: 640px) {
  .mt-dialog-style-normalize .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
}
.view-dialog-style-normalize{
  z-index: 999 !important;
}
.mt-dialog-style-normalize .pl-9 {
  padding-left: 2.25rem !important;
}`, "",{"version":3,"sources":["webpack://./src/Public/css/mt-modules-scoped.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,YAAY;AACd;;;AAGA;;;;;;;;EAQE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;MACI,8CAA8C;EAClD;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,8CAA8C;EAChD;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC","sourcesContent":[".mt-module-style-normalize img,\n.mt-module-style-normalize video{\n  max-width: 100%;\n  height: auto;\n}\n\n\n.mt-module-style-normalize img,\n.mt-module-style-normalize svg,\n.mt-module-style-normalize video,\n.mt-module-style-normalize canvas,\n.mt-module-style-normalize audio,\n.mt-module-style-normalize iframe,\n.mt-module-style-normalize embed,\n.mt-module-style-normalize object {\n  display: block;\n  vertical-align: middle;\n}\n\n.mt-module-style-normalize .text-secondary-foreground {\n  background-color: hsl(187 65% 92%) !important;\n}\n.mt-module-style-normalize .bg-secondary {\n  background-color: hsl(187 65% 92%) !important;\n}\n.mt-module-style-normalize .p-4 {\n  padding: 1rem !important;\n}\n.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100, .mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {\n  opacity: 1 !important;\n}\n\nbody > *:not(.mt-module-style-normalize) img,\nbody > *:not(.mt-module-style-normalize) svg,\nbody > *:not(.mt-module-style-normalize) video {\n  display: initial;\n}\nbody > *:not(.mt-module-style-normalize) .collapse{\n  visibility: unset;\n}\n\n.mt-module-style-normalize{\n  contain: style;\n  padding: 0 !important;\n}\n@media (min-width: 1280px) {\n  .mt-module-style-normalize .xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .lg\\:grid-cols-5 {\n    grid-template-columns: repeat(5,minmax(0,1fr)) !important;\n  } \n  .mt-module-style-normalize .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6,minmax(0,1fr)) !important;\n  }\n  .mt-module-style-normalize  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr)) !important;\n  }\n  .booking-view-top-card-view .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6,minmax(0,1fr)) !important;\n  }\n  .mt-module-style-normalize .xl\\:grid-cols-5 {\n    grid-template-columns: repeat(5,minmax(0,1fr)) !important;\n  }\n}\n.mt-module-style-normalize .collapse {\n  visibility: collapse;\n}\n.booking-calendar-view .booking-Calendar-container.flex.w-full{\n  padding-left: 30px !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected=\"true\"] {\n  background-color: hsl(198 88% 95%) !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected=\"true\"] {\n  color: hsl(198 88% 28%) !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {\n  background-color: hsl(198 88% 44%) !important;\n}\n\n.mt-dialog-style-normalize .bg-secondary {\n  background-color: hsl(210 40% 96.1%);\n}\n.mt-dialog-style-normalize .text-secondary-foreground {\n  color: hsl(215 25% 15%);\n}\n.mt-module-style-normalize .p-5 {\n  padding: 1.25rem !important;\n}\n.mt-module-style-normalize .p-4 {\n  padding: 1rem !important;\n}\n.mt-module-style-normalize .p-3 {\n  padding: 0.75rem !important;\n}\n.mt-module-style-normalize .px-5 {\n  padding-left: 1.25rem !important;\n  padding-right: 1.25rem !important;\n}\n.mt-module-style-normalize .gap-4 {\n  gap: 1rem !important;\n}\n.mt-module-style-normalize .py-4 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n.mt-module-style-normalize .py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n.mt-module-style-normalize .py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.mt-dialog-style-normalize .p-5 {\n  padding: 1.25rem !important;\n}\n.mt-dialog-style-normalize .p-4 {\n  padding: 0.75rem !important;\n}\n.mt-dialog-style-normalize .p-3 {\n  padding: 0.5rem !important;\n}\n@media (min-width: 768px) {\n  .mt-dialog-style-normalize .md\\:grid-cols-5 {\n      grid-template-columns: repeat(5,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .md\\:flex-row {\n    flex-direction: row;\n  }\n}\n@media (min-width: 640px) {\n  .mt-dialog-style-normalize .sm\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n}\n.view-dialog-style-normalize{\n  z-index: 999 !important;\n}\n.mt-dialog-style-normalize .pl-9 {\n  padding-left: 2.25rem !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
